import { useContext } from "react";
import appConst from "../Utilities/appConst.json";
import "../styles/basketItemDiscount.css";
import { LanguageContext } from "../context/language/LanguageContext";
import { detailedBookFormatMap, bookCoversMap } from "../Utilities/mapUtil";

const BasketItemOrdersUnionDetails = (props) => {
  const languageContext = useContext(LanguageContext);
  const title =
    languageContext.getTranslation(appConst.ALBUM) + " " + props.bookName;

  return (
    <div>
      <div className="basket_item_title">
        <h3>{title}</h3>
      </div>
      <div>
        <div className="basket_details_default">
          <div className="box_item copies">
            <div>
              {" "}
              {languageContext.getTranslation(appConst.COPIES)}:{" "}
              {props.quantity}{" "}
            </div>
          </div>
          <div className="box_item copies">
            <div>
              {" "}
              {languageContext.getTranslation(appConst.FORMAT)}:{" "}
              {languageContext.getTranslation(
                languageContext.getTranslation(
                  detailedBookFormatMap.get(props.format)
                )
              )}
            </div>
          </div>
          <div className="box_item copies">
            <div>
              {" "}
              {languageContext.getTranslation(appConst.COVER)}:{" "}
              {languageContext.getTranslation(
                languageContext.getTranslation(bookCoversMap.get(props.cover))
              )}
            </div>
          </div>
          <div className="box_item copies">
            <div>
              {" "}
              {languageContext.getTranslation(appConst.PAGES_NUMBER)}:{" "}
              {props.pagesNumber}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default BasketItemOrdersUnionDetails;
